import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { BreadcrumbItem, Product, ProductCategory } from '@scalefast/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbHelper } from '../helpers/breadcrumb.helper';

@Injectable({
  providedIn: 'root',
})
export class CustomProductBreadcrumbService {
  private readonly _breadcrumbs$ = new BehaviorSubject<BreadcrumbItem[]>([]);
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();
  private breadcrumbs: BreadcrumbItem[] = [];
  private locale = inject(LOCALE_ID);

  setProductBreadcrumbs(product: Product): void {
    this.breadcrumbs = this.generateCategoryPath(product.categories);
    // Sanitize the breadcrumb
    this.sanitizeBreadcrumb();
    this._breadcrumbs$.next(this.breadcrumbs);
  }

  private generateCategoryPath(productCategories: ProductCategory[]): BreadcrumbItem[] {
    const categoriesBreadcrumbs: BreadcrumbItem[] = [];
    //limit the number of categories to 2
    if (productCategories && productCategories.length > 0) {
      for (let i = 0; i < 2; i++) {
        const categoryLabelSanitised = productCategories[i].categoryName
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/ /g, '-')
          .toLowerCase();
        const path = categoriesBreadcrumbs[i - 1]
          ? `${categoriesBreadcrumbs[i - 1].path}/${categoryLabelSanitised}`
          : `/${categoryLabelSanitised}`;
        categoriesBreadcrumbs.push({ label: productCategories[i].categoryName, path: path });
      }
    }
    return categoriesBreadcrumbs;
  }

  /**
   * Sanitize the breadcrumb
   */
  private sanitizeBreadcrumb() {
    this.breadcrumbs = BreadcrumbHelper.removeOrphanedBreadcrumb(this.breadcrumbs);
    this.breadcrumbs = BreadcrumbHelper.removeColonsFromBreadcrumb(this.breadcrumbs);
    this.breadcrumbs = BreadcrumbHelper.removeHyphensFromBreadcrumb(this.breadcrumbs);
  }
}
